
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/support",
      function () {
        return require("private-next-pages/sub/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/support"])
      });
    }
  